

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    {
        const HERO = document.querySelector('.split-hero')
        if(!HERO) return

        const content = [
            HERO.querySelector('.breadcrumbs'),
            HERO.querySelector('.split-hero--details h1'),
            HERO.querySelector('.split-hero--details h3'),
            HERO.querySelector('.split-hero--details .wysiwyg'),
            HERO.querySelector('.split-hero--time'),
            HERO.querySelector('.split-hero--actions'),
            HERO.querySelector('.split-hero--social'),
        ]

        const image = HERO.querySelector('.split-hero--image')

        const timeline = gsap.timeline({
            ease: 'power2.inOut'
        })

        timeline.to(content, {
                stagger: 0.05,
                opacity: 1,
                translateY: 0,
            })
            .to(image, { opacity: 1, translateX: 0 }, "<")
    }
}
